import React from 'react'
import { lighten } from 'polished'
import styled, { withTheme } from 'styled-components'
import Wheel from './wheel'

const Wrapper = styled.div`
    background-color: white;
    padding: 16px;
    border-radius: 8px;
    text-align: center;
    font-family: ${(props) => props.theme.fontTypes.header};
    border-bottom: 1px solid ${(props) => props.theme.palette.greyScale.lightGrey};

    span.value {
        font-size: 20px;
        font-weight: bold;
        display: block;
        margin-bottom: -5px;
    }
`

const CardTitle = styled.div`
    margin-bottom: 14px;
    font-size: 0.67em;
    font-weight: bold;
`

export const Card = ({ theme, value, label, title, wheelProps }) => (
    <Wrapper className="box-shadow">
        <CardTitle>{title}</CardTitle>
        <Wheel
            strokeWidth={8}
            backgroundStrokeColor={lighten(0.12, theme.palette.greyScale.altGrey)}
            {...wheelProps}
        >
            <div>
                <span className="value">{value}</span>
                <span>{label}</span>
            </div>
        </Wheel>
    </Wrapper>
)

export default withTheme(Card)
